module.exports = __webpack_public_path__ + "templates/modal_message.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/templates/modal_message.html
// module id = 58AI
// module chunks = 1